export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <span className="text-lg font-heading text-background-50">海角网</span>
            <p className="text-xs text-background-400 mt-3 leading-relaxed">
              海角网免费在线观看平台，提供海角网免费看、海角免费视频及海角在线观看免费服务，无需付费即可畅享海量原创内容与免费资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">专题合集</a>
              <a href="#features" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">平台特色</a>
              <a href="#ranking" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">热搜榜单</a>
              <a href="#faq" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-3">内容分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">悬疑剧场</a>
              <a href="#index" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">动漫专区</a>
              <a href="#index" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">纪录之窗</a>
              <a href="#index" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">经典重制</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-3">合作伙伴</h4>
            <p className="text-xs text-background-500">平台内容由多家合作伙伴共同提供，持续拓展中。</p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 海角网 - 海角免费视频资源在线观看免费入口
          </p>
          <p className="text-xs text-background-500">
            海角网在线 · 海角网免费看 · 海角免费视频
          </p>
        </div>
      </div>
    </footer>
  );
}